<template>
  <section>
    <h3 class="experience-title">Work Experience</h3>
    <ul class="timeline">
      <!-- Monetech Servicios -->
      <li class="timeline-item rounded">
        <div class="experience-item-head-row">
          <h4 class="experience-item-head-company current">Monetech Servicios</h4>
          <h5>Europe | Remote</h5>
        </div>
        <div class="experience-role-block">
          <div class="experience-item-head-row">
            <h4 class="experience-role-title">Head of Customer-Facing Delivery</h4>
            <h5 class="experience-role-dates">October 2025 – present</h5>
          </div>
        </div>
        <div class="experience-role-block">
          <div class="experience-item-head-row">
            <h4 class="experience-role-title">Lead Full Stack Engineer</h4>
            <h5 class="experience-role-dates">January 2024 – October 2025</h5>
          </div>
        </div>
        <div class="experience-item-text">
          <p>
            <i>></i> Partnered with Marketing and Risk to improve acquisition quality and volume — growing daily loan
            issuance from ~100 to 460+ through engineering-led funnel, analytics, and product initiatives.
          </p>
          <p>
            <i>></i> As Head of Customer-Facing Delivery, leading a team of 11 engineers across lending and BNPL products
            — owning roadmap prioritization, release cadence, and alignment with Product, Risk, and business
            stakeholders.
          </p>
          <p>
            <i>></i> Promoted from Lead Full Stack Engineer; bridge business and engineering to translate strategic
            goals into scalable product architecture and predictable, high-quality delivery.
          </p>
          <p>
            <i>></i> Drove cross-sell mechanics linking BNPL and loan products, unlocking incremental revenue from the
            existing customer base.
          </p>
          <p>
            <i>></i> Delivered
            <a class="link-no-decoration" target="_blank" href="https://slana.mx/"><b>Slana</b></a>
            customer-facing product suite (lending + BNPL) —
            <a class="link-no-decoration" target="_blank" href="https://slana.mx/">slana.mx</a>,
            <a class="link-no-decoration" target="_blank" href="https://pay.slana.mx/">pay.slana.mx</a>,
            <a class="link-no-decoration" target="_blank" href="https://bnpl.slana.mx/">bnpl.slana.mx</a>,
            <a class="link-no-decoration" target="_blank" href="https://my.slana.mx/">my.slana.mx</a>
            — on React/AWS with unified data and observability stack (GA / GTM / BigQuery / Appsflyer, DWH / Quicksight,
            MS Clarity) to guide product, marketing, and risk decisions.
          </p>
        </div>
        <div class="experience-labels-row">
          <span class="label-item skill">Engineering Leadership</span>
          <span class="label-item skill">People Management</span>
          <span class="label-item skill">Fintech</span>
          <span class="label-item skill">Payments</span>
          <span class="label-item technology">React</span>
          <span class="label-item technology">TypeScript</span>
          <span class="label-item technology">AWS</span>
          <span class="label-item technology">CI/CD</span>
          <span class="label-item technology">Google Analytics</span>
          <span class="label-item technology">Google Tag Manager</span>
        </div>
      </li>

      <!-- Unlimit -->
      <li class="timeline-item rounded">
        <div class="experience-item-head-row">
          <h4 class="experience-item-head-company">Unlimit</h4>
          <h5>France | Remote</h5>
        </div>
        <div class="experience-role-block">
          <div class="experience-item-head-row">
            <h4 class="experience-role-title">Lead Frontend Engineer</h4>
            <h5 class="experience-role-dates">September 2022 – February 2025</h5>
          </div>
        </div>
        <div class="experience-item-text">
          <p>
            <i>></i> Led a team of 4 engineers, 2 analytics specialists, and a designer building an international
            fintech platform (microservices + multiple web apps); contributed to AWS cloud migration.
          </p>
          <p>
            <i>></i> Delivered
            <a class="link-no-decoration" target="_blank" href="https://demo.unlimit.com/ma-new/#/dashboard"><b>Merchant
                Account product demo</b><span style="padding-left: 5px">🔗</span></a>
            for Unlimit's international payments platform — interactive sales and onboarding showcase with
            deployment and versioning pipelines (Angular, GitLab CI/CD, AWS).
          </p>
          <p>
            <i>></i> Owned regional onboarding app expansion and integrated KYC verification into
            the customer signup flow.
          </p>
          <p>
            <i>></i> Drove cross-project code quality improvements and team upskilling initiatives.
          </p>
        </div>
        <div class="experience-labels-row">
          <span class="label-item technology">Angular</span>
          <span class="label-item technology">React</span>
          <span class="label-item technology">TypeScript</span>
          <span class="label-item technology">NodeJS</span>
          <span class="label-item technology">AWS</span>
          <span class="label-item skill">Fintech</span>
          <span class="label-item skill">Payments</span>
          <span class="label-item skill">Team Leadership</span>
          <span class="label-item skill">Project Management</span>
        </div>
      </li>

      <!-- Cargoo -->
      <li class="timeline-item rounded">
        <div class="experience-item-head-row">
          <h4 class="experience-item-head-company">Cargoo</h4>
          <h5>Switzerland | Remote · Contractor</h5>
        </div>
        <div class="experience-role-block">
          <div class="experience-item-head-row">
            <h4 class="experience-role-title">Senior Frontend Engineer — Side project</h4>
            <h5 class="experience-role-dates">September 2022 – April 2023</h5>
          </div>
        </div>
        <div class="experience-item-text">
          <p>
            <i>></i> Built logistics document management system serving US and Mexican enterprise
            customers.
          </p>
          <p>
            <i>></i> Led framework migration and introduced code-quality tooling (Sonar, Docker) across
            the frontend codebase.
          </p>
          <p>
            <i>></i> Partnered with product and UX on feature design for large customer onboarding
            initiatives.
          </p>
        </div>
        <div class="experience-labels-row">
          <span class="label-item technology">VueJS</span>
          <span class="label-item technology">TypeScript</span>
          <span class="label-item technology">PHP</span>
          <span class="label-item technology">Laravel</span>
          <span class="label-item skill">Logistics</span>
          <span class="label-item skill">Azure</span>
          <span class="label-item skill">Docker</span>
          <span class="label-item skill">Sonar</span>
        </div>
      </li>

      <!-- Riverty -->
      <li class="timeline-item rounded">
        <div class="experience-item-head-row">
          <h4 class="experience-item-head-company">Riverty</h4>
          <h5>Tallinn | Estonia</h5>
        </div>
        <div class="experience-role-block">
          <div class="experience-item-head-row">
            <h4 class="experience-role-title">Application Architect | Team Leader</h4>
            <h5 class="experience-role-dates">March 2022 – September 2022</h5>
          </div>
        </div>
        <div class="experience-role-block">
          <div class="experience-item-head-row">
            <h4 class="experience-role-title">Senior Frontend Engineer</h4>
            <h5 class="experience-role-dates">July 2021 – March 2022</h5>
          </div>
        </div>
        <div class="experience-item-text">
          <p>
            <i>></i> Designed and published an internal StencilJS web-components library via npm;
            adopted by multiple teams company-wide.
          </p>
          <p>
            <i>></i> Built client onboarding automation components that became a standalone product
            and improved client satisfaction scores.
          </p>
          <p>
            <i>></i> Promoted to Architect / Team Leader — stood up a new team, hired first engineers,
            and shipped onboarding integrations to the client portal.
          </p>
          <p>
            <i>></i> Established user monitoring for shared UI components to track production quality
            and usage.
          </p>
        </div>
        <div class="experience-labels-row">
          <span class="label-item technology">StencilJS</span>
          <span class="label-item technology">TypeScript</span>
          <span class="label-item technology">Angular</span>
          <span class="label-item skill">Web Components</span>
          <span class="label-item skill">Fintech</span>
          <span class="label-item skill">Team Leading</span>
          <span class="label-item skill">Azure</span>
          <span class="label-item skill">MongoDB</span>
        </div>
      </li>

      <!-- CGI Group -->
      <li class="timeline-item rounded">
        <div class="experience-item-head-row">
          <h4 class="experience-item-head-company">CGI Group</h4>
          <h5>Prague · Tallinn · Haugesund</h5>
        </div>
        <div class="experience-role-block">
          <div class="experience-item-head-row">
            <h4 class="experience-role-title">Senior Software Developer / Team Lead</h4>
            <h5 class="experience-role-dates">September 2018 – July 2021</h5>
          </div>
        </div>
        <div class="experience-role-block">
          <div class="experience-item-head-row">
            <h4 class="experience-role-title">Software Developer → Senior Software Engineer</h4>
            <h5 class="experience-role-dates">February 2016 – September 2018</h5>
          </div>
        </div>
        <div class="experience-item-text">
          <p>
            <i>></i> Progressed from Software Developer to Senior / Team Lead across banking,
            insurance, and energy projects at a global consultancy — promoted to Senior within two
            years.
          </p>
          <p>
            <i>></i> Led full-stack team of 6 engineers on Norwegian energy market launch: greenfield architecture,
            POC, client demo, and first production release.
          </p>
          <p>
            <i>></i> Introduced micro-frontends architecture and a shared design system; accelerated
            delivery and unlocked new client opportunities.
          </p>
          <p>
            <i>></i> Drove UI modernization for international bank and insurance clients — Angular
            migration, role-based access, and high-volume data applications.
          </p>
          <p>
            <i>></i> Ran hiring pipeline: technical interviews, take-home tasks, and onboarding for
            new team members.
          </p>
          <p>
            <i>></i> Earlier career: freelance web developer (2013–2015), delivering 10+ e-commerce and logistics
            projects across PHP, JavaScript, and WordPress.
          </p>
        </div>
        <div class="experience-labels-row">
          <span class="label-item technology">Angular</span>
          <span class="label-item technology">VueJS</span>
          <span class="label-item technology">TypeScript</span>
          <span class="label-item technology">Java</span>
          <span class="label-item technology">GRPC</span>
          <span class="label-item skill">Full Stack</span>
          <span class="label-item skill">Team Leading</span>
          <span class="label-item skill">Google Cloud</span>
          <span class="label-item skill">Banking</span>
          <span class="label-item skill">Insurance</span>
          <span class="label-item skill">Energy Industry</span>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: "ResumeExperience"
};
</script>

<style lang="scss" scoped>
.experience-title {
  font-size: 1.55rem;
  color: #23415d;
  text-align: left;
  text-transform: uppercase;
  border-bottom: 1px solid #23415d;
}

ul.timeline {
  list-style-type: none;
  position: relative;
  padding-left: 1.5rem;
}

ul.timeline:before {
  content: " ";
  background: #23415d;
  display: inline-block;
  position: absolute;
  left: 16px;
  width: 4px;
  height: 100%;
  z-index: 400;
  border-radius: 1rem;
}

li.timeline-item {
  margin: 20px 0;
  margin-left: 10px;
}

li.timeline-item::before {
  content: " ";
  background: #4b7ca9;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  border: 3px solid #fff;
  left: 11px;
  width: 14px;
  height: 14px;
  z-index: 400;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

.experience-item-head-company {
  position: relative;
  text-align: left;
  font-size: 30px;
  color: #23415d;
}

.experience-item-head-row {
  display: flex;
  width: 100%;
  text-align: left;
  flex-flow: row wrap;
  justify-content: space-between;
}

.experience-role-block {
  margin-top: 6px;
  padding-left: 12px;
  border-left: 2px solid rgba(75, 124, 169, 0.45);
}

.experience-role-title {
  font-size: 18px;
  font-weight: 600;
  color: #23415d;
}

.experience-role-dates {
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
}

.experience-item-text {
  padding: 5px;
  text-align: left;
  font-size: 14px;
  line-height: 20px;
}

.experience-labels-row {
  display: flex;
  flex-flow: row wrap;
  gap: 5px;
  width: 80%;
  margin-top: 8px;
}

.label-item {
  height: 25px;
  font-size: 11px;
  color: white;
  font-weight: 700;
  padding-inline: 5px;
  border-radius: 3px;
  text-align: center;
  vertical-align: middle;

  display: flex;
  place-content: center;
  place-items: center;
}

.technology {
  background-color: #f6fbff;
  color: black;
}

.skill {
  background-color: #f6fbff;
  color: black;
}

.link-no-decoration {
  text-decoration: none;
  color: #23415d;

  &:visited {
    text-decoration: none;
  }
}

.current::after {
  content: "( Current )";
  color: #23415d7b;
  position: absolute;
  font-size: 11px;
  transform: translateY(-35%);
}
</style>
